import type { IIconsButtonProps } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";
import type { ReactNode } from "react";

type RedirectButtonProps = Required<Pick<IIconsButtonProps, "type" | "onClick">> & {
    children?: ReactNode;
};

const RedirectButton = ({ type, children, onClick }: RedirectButtonProps) => {
    return (
        <IconButton
            type={type}
            iconName="arrow-right"
            placement="right"
            onClick={onClick}
        >
            {children}
        </IconButton>
    );
};

export default RedirectButton;
